import { render, staticRenderFns } from "./NsPhoneNumber.vue?vue&type=template&id=b8caa280&scoped=true&"
import script from "./NsPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./NsPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./NsPhoneNumber.vue?vue&type=style&index=0&id=b8caa280&lang=scss&scoped=true&"
import style1 from "./NsPhoneNumber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8caa280",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8caa280')) {
      api.createRecord('b8caa280', component.options)
    } else {
      api.reload('b8caa280', component.options)
    }
    module.hot.accept("./NsPhoneNumber.vue?vue&type=template&id=b8caa280&scoped=true&", function () {
      api.rerender('b8caa280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsPhoneNumber.vue"
export default component.exports